import React from "react";

interface QuerySnippetProps {
    arg: { name: string; value: string };
}

const QuerySnippet: React.FC<QuerySnippetProps> = ({ arg }) => {
    const [copied, setCopied] = React.useState(false);

    const handleCopy = () => {
        navigator.clipboard.writeText(arg.value);
        setCopied(true);
        setTimeout(() => setCopied(false), 1500);
    };

    return (
        <div
            style={{
                background: "rgb(241, 241, 241)",
                border: "1px solid rgb(221, 221, 221)",
                borderRadius: "8px",
                padding: "10px",
                position: "relative",
                overflowX: "auto",
            }}
        >
            <strong>{arg.name}</strong>
            <pre
                style={{
                    marginTop: "4px",
                    fontFamily: "'Consolas', 'Courier New', monospace",
                    fontSize: "13px",
                    whiteSpace: "pre-wrap",
                    wordBreak: "break-word",
                }}
            >
                {arg.value}
            </pre>

            <button
                onClick={handleCopy}
                title={copied ? "Copied!" : "Copy query"}
                style={{
                    position: "absolute",
                    top: "6px",
                    right: "6px",
                    display: "flex",
                    alignItems: "center",
                    gap: "4px",
                    border: "none",
                    background: "transparent",
                    cursor: "pointer",
                    fontSize: "12px",
                }}
            >

                <span
                    style={{
                        color: copied ? "rgb(16, 124, 16)" : "rgb(0, 120, 215)",
                        transition: "color 0.2s",
                    }}
                >
                    {copied ? "Copied" : "Copy"}
                </span>
            </button>
        </div>
    );
};

export default QuerySnippet;
